import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  inject,
} from '@angular/core';
import { Store } from '@ngxs/store';
import { FilterService } from '@wilson/filter';
import {
  SetTimelineAssignmentModalFilters,
  ShiftTimelineSettingsState,
  TimelineModalSetSearchTerm,
  ResetTimelineAssignmentModalFiltersState,
} from '@wilson/shift-timeline/state';
import { map } from 'rxjs';

@Component({
  selector: 'wilson-find-staff-popup-filters',
  templateUrl: './find-staff-popup-filters.component.html',
  styleUrls: ['./find-staff-popup-filters.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FindStaffPopupFiltersComponent implements OnDestroy {
  private store = inject(Store);
  private readonly filterService = inject(FilterService);

  public gridTemplateColumns$ = this.store
    .select(ShiftTimelineSettingsState.resourcesColumnWidthPx)
    .pipe(map((px) => `calc(${px}px - 1rem) 1fr 2fr`));

  ngOnDestroy(): void {
    this.store.dispatch(new ResetTimelineAssignmentModalFiltersState());
    this.filterService.resetAllQueryParams();
  }

  orgUnitsChanged(orgUnit: string[]) {
    this.store.dispatch(
      new SetTimelineAssignmentModalFilters({
        orgUnit,
      }),
    );
  }

  updateSearchTerm(searchTerm: string) {
    this.store.dispatch(new TimelineModalSetSearchTerm(searchTerm));
  }
}
